// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --awl-primary: #01978d;
  --awl-secondary: #007bff;
  --text-dark: #1f2937;
  --text-light: #6b7280;
  --bg-main: #f3f4f6;
  --bg-card: #ffffff;
  --border-color: #e5e7eb;
}

.app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background-color: var(--bg-card);
  border-bottom: 1px solid var(--border-color);
}
.app-name-header {
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--text-dark);
  margin: 0;
}
.app-name-highlight {
  color: var(--awl-primary);
}
.company-logo-header {
  height: 28px;
  width: auto;
}

.feedback-page {
  background-color: var(--bg-main);
  padding: 1rem;
  padding-bottom: 0.5rem;
}

.feedback-intro {
  text-align: center;
  margin-bottom: 0.5rem;
}
.page-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-dark);
}
.page-subtitle {
  font-size: 0.9rem;
  color: var(--text-light);
  margin-top: 0.25rem;
}

.card {
  background-color: var(--bg-card);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid var(--border-color);
}

.form-group {
  margin-bottom: 1rem;
}
.form-group:last-child {
  margin-bottom: 0;
}
.form-group label {
  display: block;
  font-weight: 600;
  font-size: 0.875rem;
  margin-bottom: 0.2rem;
  color: var(--text-dark);
}

.form-group input[type="text"],
.form-group textarea,
.upload-btn {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--border-color);
  background-color: #f9fafb;
  border-radius: 0.5rem;
  padding: 0.5rem;
  font-size: 1rem;
  font-family: "Inter", sans-serif;
  transition: all 0.2s ease-in-out;
}
.form-group input[type="text"]:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--awl-primary);
  background-color: white;
  box-shadow: 0 0 0 3px rgba(1, 151, 141, 0.15);
}

.attachment-info {
  font-size: 0.8rem;
  color: var(--text-light);
  margin-bottom: 0.65rem;
}

.upload-btn {
  display: block;
  text-align: center;
  border-style: dashed;
  color: var(--text-light);
  font-weight: 500;
  cursor: pointer;
}
.upload-btn:hover {
  background-color: #f0f9ff;
  border-color: var(--awl-secondary);
  color: var(--awl-secondary);
}

.submit-btn {
  width: 100%;
  background: var(--awl-primary);
  color: white;
  padding: 0.9rem 1rem;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  margin-top: 1rem;
  transition: background-color 0.2s ease;
}
.submit-btn:hover {
  background: #017c73;
}

.emoji-group {
  text-align: center;
}
.emoji-rating {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 0.75rem;
}
.emoji-btn {
  font-size: 2rem;
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1),
    background-color 0.2s ease;
  line-height: 1;
}
.emoji-btn:hover {
  transform: scale(1.15);
}
.emoji-btn.selected {
  transform: scale(1.3);
  background-color: #e0f2fe;
}
.emoji-label {
  margin-top: 0.75rem;
  font-weight: 600;
  color: var(--awl-primary);
  animation: fadeIn 0.3s ease;
}

.modal {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: 1.5rem;
}
.modal-content {
  position: relative;
  background: white;
  border-radius: 1rem;
  padding: 1.5rem;
  width: 100%;
  max-width: 12rem;
  text-align: center;
}
.close-modal-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  background: none;
  border: none;
  font-size: 1.75rem;
  color: #9ca3af;
  cursor: pointer;
}
.modal-content h2 {
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
  color: var(--awl-primary);
}
.modal-content p {
  color: #6b7280;
  margin-bottom: 1.2rem;
}
.btn-primary {
  width: 100%;
  background: var(--awl-primary);
  color: white;
  padding: 0.75rem;
  border-radius: 9999px;
  font-weight: 600;
  border: none;
  cursor: pointer;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Feedback.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;;EAGE,WAAW;EACX,sBAAsB;EACtB,qCAAqC;EACrC,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,gCAAgC;AAClC;AACA;;EAEE,aAAa;EACb,gCAAgC;EAChC,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf;8BAC4B;EAC5B,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[":root {\n  --awl-primary: #01978d;\n  --awl-secondary: #007bff;\n  --text-dark: #1f2937;\n  --text-light: #6b7280;\n  --bg-main: #f3f4f6;\n  --bg-card: #ffffff;\n  --border-color: #e5e7eb;\n}\n\n.app-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  background-color: var(--bg-card);\n  border-bottom: 1px solid var(--border-color);\n}\n.app-name-header {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: var(--text-dark);\n  margin: 0;\n}\n.app-name-highlight {\n  color: var(--awl-primary);\n}\n.company-logo-header {\n  height: 28px;\n  width: auto;\n}\n\n.feedback-page {\n  background-color: var(--bg-main);\n  padding: 1rem;\n  padding-bottom: 0.5rem;\n}\n\n.feedback-intro {\n  text-align: center;\n  margin-bottom: 0.5rem;\n}\n.page-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-dark);\n}\n.page-subtitle {\n  font-size: 0.9rem;\n  color: var(--text-light);\n  margin-top: 0.25rem;\n}\n\n.card {\n  background-color: var(--bg-card);\n  padding: 1.5rem;\n  border-radius: 1rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid var(--border-color);\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n.form-group:last-child {\n  margin-bottom: 0;\n}\n.form-group label {\n  display: block;\n  font-weight: 600;\n  font-size: 0.875rem;\n  margin-bottom: 0.2rem;\n  color: var(--text-dark);\n}\n\n.form-group input[type=\"text\"],\n.form-group textarea,\n.upload-btn {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid var(--border-color);\n  background-color: #f9fafb;\n  border-radius: 0.5rem;\n  padding: 0.5rem;\n  font-size: 1rem;\n  font-family: \"Inter\", sans-serif;\n  transition: all 0.2s ease-in-out;\n}\n.form-group input[type=\"text\"]:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--awl-primary);\n  background-color: white;\n  box-shadow: 0 0 0 3px rgba(1, 151, 141, 0.15);\n}\n\n.attachment-info {\n  font-size: 0.8rem;\n  color: var(--text-light);\n  margin-bottom: 0.65rem;\n}\n\n.upload-btn {\n  display: block;\n  text-align: center;\n  border-style: dashed;\n  color: var(--text-light);\n  font-weight: 500;\n  cursor: pointer;\n}\n.upload-btn:hover {\n  background-color: #f0f9ff;\n  border-color: var(--awl-secondary);\n  color: var(--awl-secondary);\n}\n\n.submit-btn {\n  width: 100%;\n  background: var(--awl-primary);\n  color: white;\n  padding: 0.9rem 1rem;\n  border-radius: 9999px;\n  font-weight: 600;\n  font-size: 1rem;\n  border: none;\n  cursor: pointer;\n  margin-top: 1rem;\n  transition: background-color 0.2s ease;\n}\n.submit-btn:hover {\n  background: #017c73;\n}\n\n.emoji-group {\n  text-align: center;\n}\n.emoji-rating {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 0.75rem;\n}\n.emoji-btn {\n  font-size: 2rem;\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1),\n    background-color 0.2s ease;\n  line-height: 1;\n}\n.emoji-btn:hover {\n  transform: scale(1.15);\n}\n.emoji-btn.selected {\n  transform: scale(1.3);\n  background-color: #e0f2fe;\n}\n.emoji-label {\n  margin-top: 0.75rem;\n  font-weight: 600;\n  color: var(--awl-primary);\n  animation: fadeIn 0.3s ease;\n}\n\n.modal {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n  padding: 1.5rem;\n}\n.modal-content {\n  position: relative;\n  background: white;\n  border-radius: 1rem;\n  padding: 1.5rem;\n  width: 100%;\n  max-width: 12rem;\n  text-align: center;\n}\n.close-modal-btn {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.75rem;\n  background: none;\n  border: none;\n  font-size: 1.75rem;\n  color: #9ca3af;\n  cursor: pointer;\n}\n.modal-content h2 {\n  font-size: 1.3rem;\n  margin-bottom: 0.5rem;\n  color: var(--awl-primary);\n}\n.modal-content p {\n  color: #6b7280;\n  margin-bottom: 1.2rem;\n}\n.btn-primary {\n  width: 100%;\n  background: var(--awl-primary);\n  color: white;\n  padding: 0.75rem;\n  border-radius: 9999px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
